// extracted by mini-css-extract-plugin
export default {"vertical":"ButtonSpacer-module__vertical___321rz"};